// Auto-generated by @fermata/grpc-zustand - DO NOT EDIT
// Generated from: @proto/gen/sites/v1/service

import type {
  CreateDeliveryPointRequest,
  CreateDeliveryPointResponse,
  DeleteDeliveryPointRequest,
  DeleteDeliveryPointResponse,
  GetDeliveryPointRequest,
  GetDeliveryPointResponse,
  ListDeliveryPointsRequest,
  ListDeliveryPointsResponse,
  UpdateDeliveryPointRequest,
  UpdateDeliveryPointResponse,
} from "@proto/gen/sites/v1/service"
import { create } from "zustand"
import { devtools, persist, subscribeWithSelector } from "zustand/middleware"
import { createJSONStorage } from "zustand/middleware"
import { immer } from "zustand/middleware/immer"
import { createMethodState, requestKey } from "../../runtime/middleware"
import { boundedLocalStorage } from "../../runtime/storage"
import type { MethodState } from "../../runtime/types"
import { getDeliveryPointClient } from "./client"

export interface DeliveryPointServiceState {
  /** State for listDeliveryPoints method */
  listDeliveryPoints: MethodState<ListDeliveryPointsResponse>
  /** State for createDeliveryPoint method */
  createDeliveryPoint: MethodState<CreateDeliveryPointResponse>
  /** State for getDeliveryPoint method */
  getDeliveryPoint: MethodState<GetDeliveryPointResponse>
  /** State for updateDeliveryPoint method */
  updateDeliveryPoint: MethodState<UpdateDeliveryPointResponse>
  /** State for deleteDeliveryPoint method */
  deleteDeliveryPoint: MethodState<DeleteDeliveryPointResponse>
  /** Call listDeliveryPoints method */
  listDeliveryPointsAsync: (req: ListDeliveryPointsRequest) => Promise<ListDeliveryPointsResponse>
  /** Call createDeliveryPoint method */
  createDeliveryPointAsync: (
    req: CreateDeliveryPointRequest
  ) => Promise<CreateDeliveryPointResponse>
  /** Call getDeliveryPoint method */
  getDeliveryPointAsync: (req: GetDeliveryPointRequest) => Promise<GetDeliveryPointResponse>
  /** Call updateDeliveryPoint method */
  updateDeliveryPointAsync: (
    req: UpdateDeliveryPointRequest
  ) => Promise<UpdateDeliveryPointResponse>
  /** Call deleteDeliveryPoint method */
  deleteDeliveryPointAsync: (
    req: DeleteDeliveryPointRequest
  ) => Promise<DeleteDeliveryPointResponse>
}

/**
 * Zustand store for DeliveryPointService
 *
 * Features:
 * - Auto-manages loading/error states per method
 * - Supports fine-grained reactivity with subscribeWithSelector
 * - Optional persistence to localStorage
 * - Redux DevTools integration
 */
export const useDeliveryPointServiceStore = create<DeliveryPointServiceState>()(
  devtools(
    persist(
      subscribeWithSelector(
        immer((set) => ({
          listDeliveryPoints: createMethodState<ListDeliveryPointsResponse>(),
          async listDeliveryPointsAsync(req: ListDeliveryPointsRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listDeliveryPoints
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeliveryPointClient().listDeliveryPoints(req)
              set((state) => {
                const slot = state.listDeliveryPoints
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listDeliveryPoints
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          createDeliveryPoint: createMethodState<CreateDeliveryPointResponse>(),
          async createDeliveryPointAsync(req: CreateDeliveryPointRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.createDeliveryPoint
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeliveryPointClient().createDeliveryPoint(req)
              set((state) => {
                const slot = state.createDeliveryPoint
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.createDeliveryPoint
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getDeliveryPoint: createMethodState<GetDeliveryPointResponse>(),
          async getDeliveryPointAsync(req: GetDeliveryPointRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getDeliveryPoint
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeliveryPointClient().getDeliveryPoint(req)
              set((state) => {
                const slot = state.getDeliveryPoint
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getDeliveryPoint
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          updateDeliveryPoint: createMethodState<UpdateDeliveryPointResponse>(),
          async updateDeliveryPointAsync(req: UpdateDeliveryPointRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.updateDeliveryPoint
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeliveryPointClient().updateDeliveryPoint(req)
              set((state) => {
                const slot = state.updateDeliveryPoint
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.updateDeliveryPoint
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          deleteDeliveryPoint: createMethodState<DeleteDeliveryPointResponse>(),
          async deleteDeliveryPointAsync(req: DeleteDeliveryPointRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.deleteDeliveryPoint
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getDeliveryPointClient().deleteDeliveryPoint(req)
              set((state) => {
                const slot = state.deleteDeliveryPoint
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.deleteDeliveryPoint
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
        }))
      ),
      {
        name: "deliveryPoint-store",
        // Bounded, non-throwing localStorage (see runtime/storage.ts): an
        // oversized or failing cache write is dropped rather than surfaced,
        // so it can never abort an unrelated store action.
        storage: createJSONStorage(() => boundedLocalStorage, {
          replacer: (key, value) => {
            // Convert BigInt to string for JSON serialization
            if (typeof value === "bigint") {
              return value.toString()
            }
            return value
          },
          reviver: (key, value) => {
            // Optionally convert string back to BigInt on deserialization
            // (but keeping as string is usually fine for display)
            return value
          },
        }),
        partialize: (state) => {
          // Only persist data, not loading/error states
          const persistedState: Partial<DeliveryPointServiceState> = {}
          {
            const slot = state.listDeliveryPoints
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listDeliveryPoints = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListDeliveryPointsResponse>
            }
          }
          {
            const slot = state.createDeliveryPoint
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.createDeliveryPoint = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<CreateDeliveryPointResponse>
            }
          }
          {
            const slot = state.getDeliveryPoint
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getDeliveryPoint = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetDeliveryPointResponse>
            }
          }
          {
            const slot = state.updateDeliveryPoint
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.updateDeliveryPoint = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<UpdateDeliveryPointResponse>
            }
          }
          {
            const slot = state.deleteDeliveryPoint
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.deleteDeliveryPoint = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<DeleteDeliveryPointResponse>
            }
          }
          return persistedState
        },
        // Persisted state written before request-keyed caching lacks `byKey`.
        // The default shallow merge replaces each method slot wholesale, which
        // would drop the freshly-initialized `byKey` map and make reads/writes
        // to `byKey[...]` throw. Re-add `byKey` for any rehydrated slot, and
        // surface any legacy top-level `data` under the no-request key so
        // no-arg hooks (the only request shape we can reconstruct) still see it
        // instead of `undefined`. Keyed reads for other requests fall through
        // to a fresh fetch, so we never serve one request's data for another.
        merge: (persisted, current) => {
          const merged = { ...current, ...(persisted as object) } as DeliveryPointServiceState
          for (const slot of Object.values(merged as unknown as Record<string, unknown>)) {
            if (
              slot &&
              typeof slot === "object" &&
              "data" in slot &&
              !("byKey" in (slot as object))
            ) {
              const s = slot as unknown as { data: unknown; byKey: Record<string, unknown> }
              s.byKey =
                s.data !== undefined
                  ? { [requestKey(undefined)]: { data: s.data, loading: false, error: undefined } }
                  : {}
            }
          }
          return merged
        },
      }
    ),
    { name: "DeliveryPointService" }
  )
)
